module.exports = __webpack_public_path__ + "img/铆钉狗狗.d9cd8fe7.gif";